import Scrollchor from 'react-scrollchor';
import React from 'react';

const ScrollDown = () => (
    <Scrollchor to="section-2" className="scroll-down-indicator">
        <div className="down-arrow play"></div>
        <div className="down-arrow play"></div>
        <div className="down-arrow play"></div>
    </Scrollchor>
);

export default ScrollDown;


// WEBPACK FOOTER //
// ./src/components/ScrollDown/ScrollDown.js